<template>
  <div class="w-full bg-gray-200 rounded-full h-2.5">
    <div class="bg-primary h-2.5 rounded-full" :style="`width: ${progress}%; transition: width 2s`"></div>
  </div>
</template>

<script>
export default {
  props: ['progress']
}
</script>
